module.exports = __webpack_public_path__ + "thumbnail.951467e6.webp";